import type { LoaderFunctionArgs } from 'react-router-dom';
import { redirect } from 'react-router-dom';

import { queryClient } from '@/app/providers/queryClient';
import { myStatusQueryDefinition } from '@/entities/me';
import { logger } from '@/shared';
import { getPendingInviteToken } from '@/shared/lib/invite-token';

import { appendReturnTo } from '../returnTo';
import { requireAuth } from '../requireAuth';

export async function clinicianAreaLoader(args: LoaderFunctionArgs): Promise<null> {
  const url = new URL(args.request.url);
  const pathname = url.pathname;

  await requireAuth(pathname);

  if (getPendingInviteToken()) {
    const clinicianUrl = appendReturnTo('/clinician', pathname);
    logger.info('router.clinicianOnboarding.redirect', {
      source: 'app/router',
      reason: 'pending_invite_token',
      pathname,
      redirectTo: clinicianUrl,
    });
    throw redirect(clinicianUrl);
  }

  const myStatus = await queryClient.ensureQueryData({
    ...myStatusQueryDefinition(),
    meta: { ...(myStatusQueryDefinition().meta ?? {}), toastOnError: false },
  });
  if (myStatus.requiresEmployeeRecord) {
    const clinicianUrl = appendReturnTo('/clinician', pathname);
    logger.info('router.clinicianOnboarding.redirect', {
      source: 'app/router',
      reason: 'requires_employee_record',
      pathname,
      redirectTo: clinicianUrl,
    });
    throw redirect(clinicianUrl);
  }

  logger.info('router.clinicianOnboarding.allowed', {
    source: 'app/router',
    pathname,
  });
  return null;
}
